import axios from 'axios'
import head from 'lodash/head'
import { load_one, load_many, _get_counts } from '../action-helpers'
import http from '@/http'
import * as R from "ramda";

// noinspection JSUnusedGlobalSymbols
export default {

    /**
     * Lädt eine Seite Personen vom Server (server-seitige Paginierung).
     */
    async loadPage({ commit }, { page = 0, size = 20, isUser } = {}) {
        const params = { page, size }
        if (isUser === '1' || isUser === 1)    params.isUser = true
        if (isUser === '0' || isUser === 0)    params.isUser = false
        const response = await http({ method: 'GET', url: 'persons', params })
        const persons = response.data.content
        commit('SET_MANY', { content: persons })
        commit('SET_COUNTS', { content: _get_counts(response.headers) })
        return { persons, total: response.data.totalElements }
    },

    create({ dispatch }, { model }) {
        return axios.post('/api/v1/persons', model).then(response => {
            return Promise.all([
                dispatch('loadOne', { id: response.data.id }),
                dispatch('loadAll', { force: true })
            ]).then(head)
        })
    },

    loadAll: load_many('persons', { setCounts: true }),
    loadAllByCompanyId: load_many('companies/:companyId/persons'),
    loadAllByCompanyIdAndIsMediaProduction: load_many('companies/:companyId/persons/media-production'),
    loadAllByBelongsToZmuekCompany: load_many('persons', { params: { company: '2' } }),
    loadAllByJobId: load_many('jobs/:jobId/persons'),
    loadAllByProductId: load_many('products/:productId/persons'),
    loadOne: load_one('persons/:id'),
    loadOneByUserId: load_one('users/:userId/person'),

    loadAllByJobModels({ dispatch }, { jobModels }) {
        return R.compose(

            // Promises zusammenfassen
            promises => Promise.all(promises),

            // Personen zu Job-IDs laden
            R.map(jobId => dispatch('loadAllByJobId', { jobId })),

            // Job-IDs auslesen
            R.map(R.prop('id'))

        )(jobModels)
    },

    update({ dispatch }, { model }) {
        return axios.put(`/api/v1/persons/${model.id}`, model).then(() => {
            return dispatch('loadOne', { id: model.id, force: true  })
        })
    },

}
